import React from 'react';
import { motion } from 'framer-motion';

const values = [
  "Guided estate tours",
  "Curated bites, desserts, drinks, and coffee tastings",
  "Conversations with trusted wedding professionals",
  "Wedding inspiration throughout the property",
  "Raffles and event experiences",
  "Access to event-only booking enhancements"
];

export default function QuickValue() {
  const scrollToRsvp = (e) => {
    e.preventDefault();
    document.getElementById('rsvp')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-ivory py-16 md:py-24 px-6 border-y border-estate-gold/10">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-serif text-3xl md:text-5xl text-burgundy mb-6 leading-tight">
              A Wedding Open House <br className="hidden md:block"/> Designed to Feel Different
            </h2>
            <p className="font-sans font-light text-charcoal/70 text-base md:text-lg leading-relaxed mb-8">
              Before choosing where you will say “I do,” spend an afternoon experiencing Padua the way your guests would—through its architecture, gardens, hospitality, music, and atmosphere.
            </p>
            <a 
              href="#rsvp" 
              onClick={scrollToRsvp}
              className="inline-block border border-burgundy text-burgundy font-sans text-[10px] md:text-xs uppercase tracking-widest px-8 md:px-10 py-4 md:py-5 hover:bg-burgundy hover:text-ivory transition-all duration-500"
            >
              Reserve My Invitation
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-aged-ivory p-8 md:p-12 border border-estate-gold/20"
          >
            <ul className="space-y-4 md:space-y-6">
              {values.map((item, idx) => (
                <li key={idx} className="flex items-start gap-4">
                  <span className="text-estate-gold mt-1">✦</span>
                  <span className="font-sans font-light text-sm md:text-base text-charcoal/80 leading-snug">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}